module.exports = __webpack_public_path__ + "img/events.70a0505b.png";